import { render, staticRenderFns } from "./MobileFooterLink.vue?vue&type=template&id=00f90daf&scoped=true"
import script from "./MobileFooterLink.vue?vue&type=script&lang=js"
export * from "./MobileFooterLink.vue?vue&type=script&lang=js"
import style0 from "./MobileFooterLink.vue?vue&type=style&index=0&id=00f90daf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f90daf",
  null
  
)

export default component.exports